import {useTranslation} from "react-i18next";
import {useState} from "react";
import {Button, Form} from "react-bootstrap";
import {GoInfo} from "react-icons/go";

export default function SimManualQuestion({ sim, setSim, setQuestion, question }) {
    const { t, i18n } = useTranslation();
    const isCorrect = (manualAnswer) => {
        var correct = 0;
        question.correct.forEach((answer, idx) => {
            if(answer.toLowerCase().trim() == manualAnswer.toLowerCase().trim())
                correct++;
        });

        return correct > 0;
    }
    const onChange = (e) => {
        console.log('on change');
        setQuestion(sim.currentQuestion, {...question, answer: e.target.value, is_correct: isCorrect(e.target.value) })
    }

    const good = isCorrect(question.answer)
    return (
        <div className={"exam-sim-question " + (question.image_uri ? 'has-image' : '')}>
            <h2 className="exam-sim-question-title">
                {question.question}
            </h2>
            <div className="exam-sim-question-body">
                <div className="exam-sim-question-image">
                    <img src={question.image_uri} alt="" />
                </div>
                <ul className="exam-sim-question-answers">
                    <li>
                        <Form.Group className="mb-3 form-floating" controlId="manual_answer">
                            <Form.Control type="text" placeholder={t('form.yourAnswer')} disabled={sim.finished} name="manual_answer" value={question.answer} onChange={(e) => onChange(e)} />
                            <Form.Label>{t('form.yourAnswer')}</Form.Label>
                        </Form.Group>
                    </li>
                    <li>
                        <p className="small text-muted"><GoInfo style={{fontSize: 16}} /> {t('form.yourAnswerNote')}</p>
                    </li>
                    {sim.finished && question.explanation !== '' && <li className={"exam-sim-question-desc " + (good ? 'good' : 'wrong')}>
                        {good ? <h3>{t('good')}</h3> : <h3>{t('wrong')}</h3>}
                        {question.explanation}
                    </li>}
                </ul>

            </div>
        </div>
    );
}
